var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-info-form',{attrs:{"contracts-loading":_vm.isLoading,"person":_vm.person,"contract-id":_vm.contractId,"next-step-path":"PartnerPortal-ReportDamage-Facts","contracts":_vm.contracts,"is-broker":true}})}
var staticRenderFns = []

export { render, staticRenderFns }